import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { ApiHelper } from '@sc/pas-common';
import { ClaimService } from 'app/components/claim/claim.service';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthService, Session } from '@sc/pas-common';

@Component({
    template: '',
    providers: [ClaimService]
})

export class LegacyBypassComponent {
    redirectClaim: string;
    redirectTo: string;

    constructor(public api: ApiHelper,
        private router: Router,
        private route: ActivatedRoute,
        private http: HttpClient,
        private claimService: ClaimService,
        private authService: AuthService) {
        route.queryParams.subscribe(params => {
            const tokenNSIIS = params['t'];
            const token = params['token'];
            const GTM1 = params['utm_source'];
            const GTM2 = params['utm_medium'];
            const GTM3 = params['utm_campaign'];
            this.redirectTo = params['redirectTo'];
            this.redirectClaim = params['redirect'];
            if (tokenNSIIS) {
                const p = GTM1 && GTM2 && GTM3 && {utm_source: GTM1, utm_medium: GTM2, utm_campaign: GTM3}
                this.authNSIIS(tokenNSIIS, p, this.deleteParamsOnRedirect(params));
            }

            if (token) {
                this.auth(token).subscribe((data: any) => {
                    if (data) {
                        const sessionData = {
                            jwt: token,
                            userId: data.userId,
                            username: data.username,
                            impersonationUserName: data.impersonationUserName,
                            impersonationUserId: data.impersonationUserId
                        } as Session;
                        this.authService.persistData(sessionData);

                        if (this.redirectTo) {
                            this.router.navigate([this.redirectTo], { queryParams: this.deleteParamsOnRedirect(params) });
                        } else {
                            this.router.navigate(['/forbidden']);
                        }
                    }
                });
            }
        });
    }

    authNSIIS(token, GTMParams = null, params) {
        this.api.auth(token).subscribe(ok => {
                if (ok) {
                    this.authService.auth(null, localStorage.getItem('tk')).subscribe(() => {
                        if (this.redirectTo) {
                            this.router.navigate([this.redirectTo], { queryParams: params });
                        } else if (this.redirectClaim) {
                            this.onEvaluateRedirectParam(this.redirectClaim, GTMParams);
                        } else {
                            this.evaluateRedirectHome(GTMParams);
                        }
                    });

                } else {
                    this.router.navigate(['forbidden'])
                }
            },
            error => {
                this.router.navigate(['forbidden'])
            })
    }

    auth(jwt) {
        this.api.logUser({ jwt });
        return this.http.get(`${environment.server.api.auth}/api/token/ValidateToken?token=${jwt}`);
    }

    onEvaluateRedirectParam(type, GTMParams) {
        switch (type) {
            case 'siniestros_auto':
                this.claimService
                .check()
                .subscribe(result => {
                    if (result && result.link) {
                        location.assign(result.link);
                    }
                });
            break;
            default:
                this.evaluateRedirectHome(GTMParams);
            break
        }
    }

    evaluateRedirectHome(GTMParams) {
        if (GTMParams) {
            this.router.navigate(['inicio'], {queryParams: GTMParams});
        } else {
            this.router.navigate(['inicio']);
        }
    }

    private deleteParamsOnRedirect(params) {
        const _params = JSON.parse(JSON.stringify(params));
        delete _params.t;
        delete _params.token;
        delete _params.redirectTo;

        return _params;
    }
}
